// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>{{data.header}}</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>{{data?.message}}</p>
            <p>{{data?.message2}}</p>
            <p>{{data?.message3}}</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130" (click)="closeDialog('Cancel')">Cancel
            </button>
            <button class="Button Button--blue Button--minWidth130" (click)="closeDialog('OK')">OK</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;